import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { StringCase, transformCase } from '@attain-apps/string-utils'

import * as me from '../../../me'
import type { Group } from '../group'

import { Api } from './api'
import * as effects from './effects'
import type { TypeParams } from './types'

export class Collection extends ec.Collection<TypeParams> {
  constructor(assistantGroup: Group) {
    const meFeature = ngCore.inject(me.Feature)
    super({
      api: new Api(assistantGroup.agentIds),
      context$: meFeature.contexts.selectors.zoneContext.asObservable,
      identify: conversation => conversation.id,
      name: ec.Name.Dynamic.from(
        `${transformCase(assistantGroup.id, StringCase.Title)}Conversation`,
      ),
      plugins: {
        currentEntity: {
          onChangeInCurrentList: (entities, currentEntityIdsLookup) => ({}),
        },
        currentList: {
          // NOTE: Default sorting - the UI currently lacks a tabular view and
          // user-configurable sort controls, so we apply the defaults below
          descending: { get: () => true },
          sortBy: {
            get: () => 'createdAt',
          },
        },
      },
    })

    this.feature.registerEffects(
      // Register the effect to group conversations by workspaceId
      effects.putWorkspaceGroups(this, assistantGroup.workspace),
      // Register the effect to group conversations by agentId
      effects.putAgentGroups(this),
      effects.onConversationAdded(this),
    )
  }
}
